import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import profile from './profile/reducer';
import langs from './langs/reducer';
import { quizzes, quiz } from './quiz/reducer';
import { quizstst } from './statistics/quiz/reducer';
import { questionsstst } from './statistics/questions/reducer';
import { linksTrackingStatistics } from './statistics/linksTracking/reducer';
import { dashboardstst } from './statistics/dashboard/reducer';
import { players,excelQuizFile } from './quiz/players/reducer';
import users from './user/reducer';
import roles from './role/reducer';
import permissions from './permissionManagement/reducer';
import rounds from './quiz/rounds/reducer';
import { settings,  editor } from './quiz/settings/reducer';
import { gameprogress, eventSound } from './player/quiz/reducer';
import { hatchGameProgress, hatchGameData, shareChallenge, calendarEventSound } from './player/calendar/reducer';
import { quizpreview  } from './quiz/preview/reducer';
import { reguser } from './player/register/reducer';
import { calendars, calendar, publish } from './calendar/reducer';
import { hatches } from './calendar/hatch/reducer';
import { questions } from './calendar/questions/reducer';
import { calendarPlayers, excelFile } from './calendar/players/reducer';
import { prizes } from './calendar/navigation/prizes/reducer';
import  localization  from './localization/reducer';
import { calendarstats } from  './statistics/calendar/reducer';
import { linksTrackingStatisticsCalendar } from  './statistics/calendar/linksTracking/reducer';
import { login } from './login/reducer';
import forgotPassword from './forgotPassword/reducer';
import resetPassword from './resetPassword/reducer';
import changePassword from './changePassword/reducer';
import { global } from './global/reducer';
import { emailSender } from './sendMail/reducer';
import { fileSender } from  './uploadFile/reducer';
import { diplomaFone } from './proxyImage/reducer';
import { customFonts } from './proxyFont/reducer';
import { countryStatistics } from './statistics/country/reducer';
import { leaderBoard } from './leaderBoard/reducer';
import { leaderBoardSettings, leaderBoardQuizList } from './leaderBoardSettings/reducer';
import { identifierUser } from './userIdentifier/reducer';
import { headerImage } from './proxyHeaderImage/reducer';
import { api } from './apiSettings/reducer';
import { actionBuffer } from './actionBuffer/reducer';
import { tenantStatistics } from './tenantStatistics/reducer';
import { calendarSettings } from './calendar/settings/reducer';
import appearanceBackground from './appearance/backgrounds/reducer';
import appearanceLogo from './appearance/logos/reducer';
import dataManagement from './dataManagement/reducer';

export default combineReducers({
    tenantStatistics,
    actionBuffer,
    profile,
    headerImage,
    api,
    quizzes,
    countryStatistics,
    quiz,
    players,
    users,
    roles,
    permissions,
    rounds,
    settings,
    editor,
    quizstst,
    questionsstst,
    linksTrackingStatistics,
    dashboardstst,
    gameprogress,
    langs,
    quizpreview,
    reguser,
    calendars,
    calendar,
    prizes,
    calendarPlayers,
    excelFile,
    excelQuizFile,
    hatchGameData,
    localization,
    hatchGameProgress,
    hatches,
    questions,
    login,
    forgotPassword,
    resetPassword,
    changePassword,
    calendarstats,
    linksTrackingStatisticsCalendar,
    shareChallenge,
    publish,
    eventSound,
    global,
    router: routerReducer,
    emailSender,
    fileSender,
    diplomaFone,
    customFonts,
    calendarEventSound,
    leaderBoard,
    leaderBoardSettings,
    leaderBoardQuizList,
    identifierUser,
    calendarSettings,
    appearanceBackground,
    appearanceLogo,
    dataManagement
});
